"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.706 9.354L12 16.06 5.294 9.354 6.708 7.94 12 13.232l5.292-5.292 1.414 1.414z" }), "ChevronDown");
//# sourceMappingURL=ChevronDown.js.map